import { Alert, Col, Row } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import "animate.css";
import { db } from "../firebase";
import { ref, push } from "firebase/database";

export const Newsletter = ({ onValidated, status, message }) => {
  const [email, setEmail] = useState("");

  useEffect(() => {
    if (status === "success") clearFields();
  }, [status]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const newsletterRef = ref(db, 'newsletter');

    push(newsletterRef, email)
      .then(()=>{
        status = 'success'
        alert("Email registrado correctamente");
        clearFields();
      })
      .catch((error)=>{
        console.log(error);
        alert("Error al registrar el email");
        status = 'error'
      })

  };

  const clearFields = () => {
    setEmail("");
  };

  return (
    <Col lg={12}>
      <div className="newsletter-bx animate__animated animate__zoomIn">
        <Row>
          <Col lg={12} md={6} xl={5}>
            <h3>Subscribe to our Newsletter</h3>
            {status === "sending" && <Alert>Sending...</Alert>}
            {status === "error" && <Alert variant="danger">{message}</Alert>}
            {status === "success" && <Alert variant="success">{message}</Alert>}
          </Col>
          <Col md={6} xl={7}>
            <form action="" onSubmit={handleSubmit}>
              <div className="new-email-bx">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email address"
                />
                <button type="submit">Submit</button>
              </div>
            </form>
          </Col>
        </Row>
      </div>
    </Col>
  );
};
